import { render, staticRenderFns } from "./plus.vue?vue&type=template&id=b7d8626c&"
import script from "./plus.vue?vue&type=script&lang=js&"
export * from "./plus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7d8626c')) {
      api.createRecord('b7d8626c', component.options)
    } else {
      api.reload('b7d8626c', component.options)
    }
    module.hot.accept("./plus.vue?vue&type=template&id=b7d8626c&", function () {
      api.rerender('b7d8626c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/plus.vue"
export default component.exports